<template>
    <footer>

        <div class="footer-wrapper">

            <div class="column">
                <p class="header-footer">Kontakt</p>
                <div>
                    <div class="container">
                        <img class="icon" src="../../assets/icons/home.svg"
                            onerror="this.onerror=null; this.src='home.svg'">
                        <div class="text">
                            Česká zoologická společnost<br />
                            Viničná 7, Praha 2<br />
                            128 00<br />
                        </div>
                    </div>

                    <div class="container">
                        <img class="icon" src="../../assets/icons/mail.svg"
                            onerror="this.onerror=null; this.src='mail.svg'">
                        <div class="text">
                            <a href="mailto:info@zoospol.cz">info@zoospol.cz</a>
                        </div>
                    </div>

                    <div class="container">
                        <img class="icon" src="../../assets/icons/globe.svg"
                            onerror="this.onerror=null; this.src='globe.svg'">
                        <div class="text">
                            <a href="https://zoospol.cz">www.zoospol.cz</a>
                        </div>
                    </div>
                </div>

            </div>
            <div class="column">
                <h3 class="header-footer">Sekretariát</h3>
                <ul>
                    <div class="container">
                        <img class="icon" src="../../assets/icons/person.svg"
                            onerror="this.onerror=null; this.src='person.svg'">
                        <div class="text">
                            Lucie Macková
                        </div>
                    </div>
                    <div class="container">
                        <img class="icon" src="../../assets/icons/home.svg"
                            onerror="this.onerror=null; this.src='home.svg'">
                        <div class="text">
                            Viničná 7, Praha 2<br />
                            1. suterén (S35)<br />
                        </div>
                    </div>
                    <div class="container">
                        <img class="icon" src="../../assets/icons/phone.svg"
                            onerror="this.onerror=null; this.src=phone.svg'">
                        <div class="text">
                            221 951 860
                        </div>
                    </div>
                    <div class="container">
                        <img class="icon" src="../../assets/icons/mail.svg"
                            onerror="this.onerror=null; this.src='mail.svg'">
                        <div class="text">
                            <a href="mailto:pazitkob@natur.cuni.cz">info@zoospol.cz</a>
                        </div>
                    </div>
                </ul>
            </div>
        </div>


        <PartnersList />
    </footer>
</template>

<script scoped>
import PartnersList from './PartnersList.vue'

export default {
    components: {
        PartnersList
    },
    data() {
        return {
        }
    },
    methods: {
        toggleItem(item) {
            item.open = !item.open;
        },
        toggleSideMenu() {
            this.isSideMenuOpen = !this.isSideMenuOpen;
        }
    },
};
</script>

<style scoped>
footer {
    margin-top: 30px;
    border-top: 2px solid #879e33;
    background-color: #94b325;
}

.footer-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    width: 800px;
    margin: 0px auto;
}

.column {
    margin-bottom: 20px;
    margin-top: 20px;
}

.icon {
    width: 20px;
    height: 20px;
    background-size: contain;
    fill: #fff;
}

.header-footer {
    text-align: center;
    font-weight: 500;
    font-size: 20px;
    margin: 0px auto;

    margin-bottom: 20px;
    color: white;
}

.header-footer {
  text-align: center; /* Center the heading */
  position: relative; /* Needed for absolute positioning of the underline */
}

.header-footer::after {
  content: ""; /* Create the underline */
  position: absolute; /* Position the underline relative to the heading */
  left: 50%; /* Center the underline horizontally */
  transform: translateX(-50%); /* Adjust for centering */
  bottom: -5px; /* Position the underline below the heading */
  width: 20%; /* Make the underline half the length of the heading */
  height: 2px; /* Set the thickness of the underline */
  background-color: white; /* Set the color of the underline to white */
}

.container {
    margin: 10px;
    display: flex;
    align-items: flex-start;
    /* Align items to the top of the container */
}

.icon {
    margin-right: 10px;
    /* Add some space between the icon and text */
}

.text {
    line-height: 1.5em;
    color: white;
}

a {
    color: white;
    text-decoration: underline dotted;
    text-underline-offset: 3px;
}

@media (max-width: 1000px) {

    .footer-wrapper {
        width: 100%;
    }
    .container{
        align-items: center;
        width: fit-content
    }

    .column {
        width: fit-content;
        margin-bottom: 20px;
    }
}
</style>